import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AiAssistantDialogComponent } from './../../shared/components/ai-assistant-dialog/ai-assistant-dialog.component';
import { FLOATING_AI_DIALOG_BASE } from './../../shared/config/floating-ai-dialog.config';
import {
  FLOATING_DIALOG_LAYOUT_KEYS,
  FloatingDialogLayoutService,
} from './floating-dialog-layout.service';

@Injectable({
  providedIn: 'root'
})
export class AiAssistantService {
  constructor(
    private dialog: MatDialog,
    private floatingLayout: FloatingDialogLayoutService
  ) { }

  // Open the chat window in a modal dialog
  openChat(patientId: string): void {
    const sizePos = this.floatingLayout.getMatDialogOpenOptions(
      FLOATING_DIALOG_LAYOUT_KEYS.aiAssistant,
      { width: '90vw', height: '90vh' }
    );
    this.dialog.open(AiAssistantDialogComponent, {
      ...FLOATING_AI_DIALOG_BASE,
      ...sizePos,
      data: { patientId },
      disableClose: true,
      panelClass: ['chat-dialog', 'floating-ai-dialog-panel', 'cura-window-panel'],
    });
  }

  // Close the chat window
  closeChat(): void {
    this.dialog.closeAll();
  }

}
